<template>
  <div>
    <div class="home"></div>
    <!-- <Banner :url="bannerUrl"></Banner> -->
    <div class="Information">
      <div
        style="display: flex;justify-content: space-between; align-items: center;"
      >
        <h2 style="color: #333333;" class="h2Item">
          资讯中心
          <span>NEWS</span>
        </h2>
        <div style="display: flex; color: #8b8b8b;margin-right: 10px;">
          <div class="More-more">···</div>
          更多
        </div>
      </div>

      <div class="i-content">
        <div class="i-content-left">
          <div class="Background-img">
            <img src="https://dl.dpgrid.com/www/imgs/home-i-2.jpg" alt="" />
          </div>
          <div class="Text-message">
            <h3 class="Text-message-Title">
              武汉大学数字摄影测量与计算机视觉研究中心揭牌
            </h3>
            <p class="Text-message-contentText">
              2004年11月由张祖勋院士创办，武汉大学数字摄影测量与计算机视觉研究中心揭牌，这意味着武汉大学数字摄影测量将与计算机视觉进行更深入、更广泛的探索；张院士指出，应发挥双方优势，将核心技术攻关和软件开发、社会服务独立分工，再以校企合作模式将学校科研成果服务于日常生活。
              当天，就该技术进行了深入交流，加强该领域基础研究、应用基础研究以及新技术、新产品的开发，并共同培养高层次专业技术人才。
            </p>
          </div>
        </div>
        <div class="i-content-right">
          <div
            style="display: flex; align-items: center; margin: 16px 0;"
            v-for="(item, index) in i_list.slice(0, 3)"
            :key="index"
            @click="DetailsPage(item.id)"
          >
            <img :src="item.url" />
            <div class="i-text">
              <h3 style="color: #333333;">{{ item.title }}</h3>
              <p>关键字：{{ item.keyword }}</p>
              <div style="#555555">{{ item.time }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="Solution">
      <div
        style="display: flex;justify-content: space-between; align-items: center;"
      >
        <h2 style="color: #333333;">
          解决方案
          <span>SOLUTION</span>
        </h2>
        <div
          style="display: flex; color: #8b8b8b;margin-right: 10px;"
          @click="ViewMore('解决方案')"
        >
          <div class="More-more">···</div>
          更多
        </div>
      </div>

      <div class="Solution-conetent">
        <div
          class="Solution-left"
          :style="{
            backgroundImage:
              'url(https://dl.dpgrid.com/www/imgs/' + SolutionBG + ')'
          }"
        >
          <div class="Solution-nav">
            <ul>
              <li
                v-for="(item, index) in projectContextList"
                @click="ISsoftware(index)"
                :key="index"
                :class="current === index ? styleLi : ''"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>

        <div class="Solution-right">
          <h3 style="color: #333333;">{{ softwareName }}</h3>
          <p class="textContext">{{ projectContext }}</p>
          <p
            style="margin: 20px 0;color: #00aaff;cursor: pointer;"
            @click="solutionDetails"
          >
            了解更多
            <i class="el-icon-right"></i>
          </p>
        </div>
      </div>
    </div>

    <div class="Product">
      <div
        style="display: flex;justify-content: space-between; align-items: center;"
      >
        <h2 style="color: #333333;">
          产品中心
          <span>PRODUCT CENTER</span>
        </h2>
        <div style="display: flex; color: #555555; margin-right: 10px;">
          <div class="More-more">···</div>
          更多
        </div>
      </div>

      <div class="Product-list">
        <div class="Product-item" v-for="(item, index) in List">
          <img :src="item.URL" alt="" />
          <h3 style="margin-top: 10px; color: #333333;" :title="item.title">
            {{ item.title }}
          </h3>
          <p style="text-indent: 2em; color: #555555;">{{ item.introduce }}</p>
          <button class="download-button" @click="download">
            立即下载
            <i class="el-icon-download"></i>
          </button>
          <div style="cursor: pointer;" @click="productDetails(index)">
            <span>了解更多</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import './less/home-page.less';
import "./less/home.less";
import jwtDecode from "jwt-decode";

// import software1 from "https://dl.dpgrid.com/www/imgs/software1.jpg";
// import software2 from "https://dl.dpgrid.com/www/imgs/software2.png";
// import software3 from "https://dl.dpgrid.com/www/imgs/software3.jpg";
// import software4 from "https://dl.dpgrid.com/www/imgs/software4.jpg";
// import software5 from "https://dl.dpgrid.com/www/imgs/software5.jpg";
// import software6 from "https://dl.dpgrid.com/www/imgs/software6.jpg";
// import software7 from "https://dl.dpgrid.com/www/imgs/software7.jpg";
// import software8 from "https://dl.dpgrid.com/www/imgs/software8.jpg";
// // import banner from "./image/home-img.jpg";
// import DPcloud from "https://dl.dpgrid.com/www/imgs/DPcloud.png";
// import DPOne from "https://dl.dpgrid.com/www/imgs/DPOne.png";
// import DPgridEDU from "https://dl.dpgrid.com/www/imgs/DPgridEDU.png";
// import DPGO from "https://dl.dpgrid.com/www/imgs/DPGO_.png";

import informationlist from "@/assets/information.js";
// import informationlist from '@/assets/solution.js';
// import Banner from "./components/banner.vue";
export default {
  components: {
    // Banner
  },
  data() {
    return {
      // bannerUrl: banner,
      current: 0,
      SolutionBG: null,
      projectContextList: [
        {
          title: "贴近摄影测量",
          URL: "software2.png",
          content:
            "贴近摄影测量（nap-of-the-object photogrammetry）是张祖勋院士团队针对精细化测量需求提出的全新摄影测量技术，它是精细化对地观测需求与旋翼无人机发展结合的必然产物。贴近摄影测量是面向对象的摄影测量（object-oriented photogrammetry），它以物体的“面”为摄影对象，通过贴近摄影获取超高分辨率影像，进行精细化地理信息提取。贴近摄影测量渊源于滑坡、高位危岩的地质调查与监测预警，并进行了初步应用试验，具有可高度还原地表和物体精细结构的特点，也可应用于城市精细重建、古建筑重建、水利工程监测等方面。"
        },
        {
          title: "无人机测绘",
          URL: "software1.jpg",
          content:
            "利用无人飞机平台搭载数码相机进行航空摄影，采用imu/gps技术进行自动导航，在1000米以下进行低空作业，快速获取高分辨率影像，利用遥感数据处理系统快速处理制作数字正射影像图（DOM）、数字高程模型（DEM）、数字表面模型（DSM）、数字线划图（DLG）、三维实景模型。应用领域：市政规划、城市变化监测、国土资源调查及遥感监测、应急救灾、环保监测、巡线（电力、石油、天然气）、资源开发、警用安防、森林巡检、农林监测与估产、文物考古、新农村和小城镇建设。"
        },
        {
          title: "倾斜摄影测量",
          URL: "software4.jpg",
          content:
            "倾斜摄影技术是国际测绘领域近年来发展起来的一项高新技术，颠覆了以往正射影像只能从垂直角度拍摄的局限，通过在同一飞行平台搭载多台传感器，同时从垂直和倾斜多个不同角度采集影像，将用户引入了符合人眼视觉的真实直观世界。无人机具有响应速度快、处理效率高、运行成本低等优势，两者结合颠覆了传统测绘的作业方式，通过无人机低空多镜头摄影获取高清晰立体影像数据，自动生成三维地理信息模型，在三维模型中进行裸眼立体测图，快速实现地理信息的获取，具有效率高、成本低、数据精确、操作灵活、侧面信息丰富等特点，满足测绘行业的不同需求。不动产测量属于地籍测量中的一种，精度要求高，传统的测量两方法利用全站仪和RTK结合完成，劳动强度高，工作量大，我们经过大量测试和工程验证，利用翼飞W5无人机倾斜摄影的裸眼立体测图方法，形成了一套利用无人机倾斜摄影方法进行高精度不动产测量方法，解决了1:500不动产测量技术难题。"
        },
        {
          title: "高校教育",
          URL: "software3.jpg",
          content:
            "虚拟仿真教学系统，改变了枯燥生硬的教学方式，立体模型、互动操作、有趣并有成就感，解决了实习设备陈旧、器材不足、难以到达现场、操作危险等难题，是传统教学方式的质变，在测绘地理信息相关专业中起到提高教学质量、强化技能培养、促进就业的作用。"
        },
        {
          title: "工程测量",
          URL: "software8.jpg",
          content:
            "工程测量是工程建设勘测设计过程中重要的基础性技术工作，工程建设的规划、可行性研究、初步设计、技施设计、工程运行、安全监测等各阶段都需要良好的测绘技术服务。我们涉及的水电工程大多属于大型或特大型工程，而这些工程主要分布在我国西部高山峡谷地区的金沙江、雅鲁藏布江、雅砻江、大渡河等流域，不仅技术复杂而且工作条件艰苦。测绘专业需要为勘测设计获取大量的高质量的测绘数据，这不仅需要比较过硬的测绘专业技术，还需要兢兢业业、吃苦耐劳的工作精神。"
        },
        {
          title: "智慧城市",
          URL: "software6.jpg",
          content:
            "测绘地理信息的飞速发展也很好地支持了社会经济建设的发展，特别是在数字城市、城市规划管理等很多领域测绘地理信息成为提高政府辅助决策的重要技术。我们为更好地为社会提供服务，积极参与相关项目的建设实践，为社会提供了一系列地理信息综合服务产品。数字城市建设是一个庞大的系统工程，我们利用在航空摄影测量技术、机载激光及地面激技术三维建模技术等领域的优势，通过温江区城市规划辅助决策系统基础地理信息建设的工程实践，很好地为政府实现了辅助性决策管理，提高了在城市规划管理方面的质量和效率，并为交通、公安、地下管网的后期建设提供了基础平台。为推动了测绘地理信息技术在数字城市领域的应用和为数字城市建设积累了相关经验。"
        },
        {
          title: "卫星影像处理",
          URL: "software7.jpg",
          content:
            "在获取基础地理数据、地球资源信息和应急灾害的第一手资料方面，遥感比其它技术手段更有优势。随着航天遥感技术的发展，获取的卫星影像分辨率越来越高（商业遥感卫星分辨率最高已经到达0.31米，WorldView-4），可以满足较大比例尺“4D”产品生产要求，且卫星影像具有获取数据范围大和周期短的特点，使得卫星遥感已经成为基础地理数据采集与更新的重要手段。在重大测绘项目中（如“全球测图”和“国土三调”等），如何处理海量、多源多时相的卫星数据影像，以及充分利用参考底图用作有效的控制，高效生产符合精度要求的数据是当前使用者最为关心的内容。该方案是基于张祖勋院士提出的“云控制”空三定位技术，采用了全新的区域网平差模式（支持立体模式和单视影像模式以及混合模式）以及高精度逐像素DSM匹配技术。除此之外还集成了简洁、高效、直观的DEM编辑模块和DOM匀光匀色、镶嵌分幅模块以及卫片测图模块，能够让您顺利的完成整个数据生产作业流程。"
        }
      ],
      softwareName: "",
      projectContext: "",
      styleLi: "styleLi",
      List: [
        {
          URL: "https://dl.dpgrid.com/www/imgs/DPOne.png",
          title: "多普智图DPOne",
          introduce:
            "多普智图（DPOne）是一款基于摄影测量与计算机视觉技术的无人机智能空三处理软件。软件自动化程度高，数据适应性强。可用于测绘4D产品生产、勘测设计和无人机电力巡检等行业应用。"
        },
        {
          URL: "https://dl.dpgrid.com/www/imgs/DPCloud.png",
          title: "多普云平台",
          introduce:
            "无人机职业教育实训平台（DPCLOUD）简称多普云，是武汉多普云科技有限公司推出的以培养无人机职业从业技能为导向，以无人机测绘、摄影测量为引擎，延伸扩展至无人机其他应用行业。提供考证资源、课程资源、软硬件资源、数据资源、技术问答、赛事资源、前沿资讯等共享服务。多普云是一个测绘知识获取的一站式应用平台，利用2+1的方式呈现，包括网页端（www.dpgrid.com）、客户端（DPCLOUD）、公众号（多普云）多种方式输出平台资源，其部署可根据用户的网络环境灵活进行，均可便捷获得线上资源及软件资源"
        },
        {
          URL: "https://dl.dpgrid.com/www/imgs/DPgridEDU.png",
          title: "DPGridEDU",
          introduce:
            "数字摄影测量网格DPGrid由中国工程院院士、武汉大学教授张祖勋提出并研制成功的，它是世界首套数字摄影测量网格(DPGrid)。DPGridEDU是专门为测绘专业院校及行业初学者定制的一个全面的集约型学习软件平台，支持数码影像数据、胶片影像数据等多种传感器的兼容，包含参数设置、快拼图生产、模型定向、空中三角测量、DEM生产、DOM生产、DLG生产、专题生产等多个功能讲解，支持粗粒度和细粒度教学模式，功能涉及面极广，是专业院校学习的好帮手。"
        },
        {
          URL: "https://dl.dpgrid.com/www/imgs/DPGO_.png",
          title: "贴近摄影测量智能航迹规划软件DPGO",
          introduce:
            "贴近摄影智能航迹规划软件DPGO是面向摄影目标的自适应多角度的三维航迹规划软件，是获取高精细三维模型解决方案中最关键的一环，结合武汉大学遥感信息学院专业算法自主研制，主要包含两款软件:DPGO 航线规划 PC 端、DPGO 飞行控制 APP 端。利用贴近物体表面(<20m )摄影获取的高清影像进行摄影测量，获取被摄物体精准坐标、精细形状，最终获得亚厘米甚至毫米级精度的三维模型、DEM、DOM 数据。"
        }
      ],
      i_list: informationlist
    };
  },
  mounted() {
    this.lsExpiration();
    this.ISsoftware(0);
  },
  methods: {
    ISsoftware(index) {
      this.current = index;
      this.softwareName = this.projectContextList[index].title;
      this.SolutionBG = this.projectContextList[index].URL;
      this.projectContext = this.projectContextList[index].content;
    },
    //点击 在新窗口网址
    ViewMore(name) {
      switch (name) {
        case "解决方案":
          window.open("https://www.dpgrid.com.cn", "break_");
          break;
      }
    },
    //跳转到 资讯中心
    solutionDetails() {
      this.$router.push({ name: "solution", params: { id: this.current } });
    },
    //跳转到 产品中心
    productDetails(index) {
      this.$router.push({ name: "product", params: { id: index } });
    },

    //token是否过期
    lsExpiration() {
      if (this.$store.state.token) {
        const jwt = jwtDecode(this.$store.state.token);
        const timestamp = Math.round(new Date() / 1000);
        const expire = jwt.exp;
        const secDiff = (timestamp - expire) / 1000;
        // console.log(secDiff);
        if (secDiff > 0) {
          this.$message.error("登录信息已过期 请重新登录！！");
          this.$store.commit("gettoken", "");
          this.$store.commit("getUserData", "");
          // setTimeout(() => {
          //   this.$router.push({ path: '/login' });
          // }, 1500);
        }
      }
    },
    download() {
      this.$router.push({ path: "/download/software" });
    },
    DetailsPage(id) {
      this.$router.push({ name: "dynamicdetails", query: { id: id } });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/home.vue